module.exports = __webpack_public_path__ + "img/contact_support_opsz20W.f7b9acd4.svg";